import { v4 } from 'uuid'

import { FormItemDraggableBase } from './form-item-draggable-base'
import { IconEnum } from '../../../../../assets/icons'
import { FormItemType } from '../../constants/form-builder.constants'

export const DateDraggable = () => {
  const id = v4()
  const type = FormItemType.Date

  return (
    <FormItemDraggableBase
      icon={IconEnum.Calendar}
      id={id}
      title="formBuilder.dateTimeField"
      type={type}
    />
  )
}
